// store/index.js
import { configureStore } from '@reduxjs/toolkit';
import persistedReducer from './reducers/index';
import { baseApi } from './baseApi';

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    // This line automatically adds default middleware like thunk, serializableCheck, etc.
    // You can also concatenate any additional middleware if needed.
    getDefaultMiddleware().concat(baseApi.middleware)
});

const { dispatch } = store;

export { store, dispatch };
